interface TimerControlsProps {
  isRunning: boolean;
  isPaused: boolean;
  isIdle: boolean;
  isComplete: boolean;
  onStart: () => void;
  onPause: () => void;
  onReset: () => void;
}

export function TimerControls({
  isRunning,
  isPaused,
  isIdle,
  isComplete,
  onStart,
  onPause,
  onReset
}: TimerControlsProps): JSX.Element {
  const getStartButtonLabel = (): string => {
    if (isPaused) return 'Resume';
    if (isComplete) return 'Restart';
    if (isIdle) return 'Start';
    return 'Start';
  };

  const showStartButton = isIdle || isPaused || isComplete;
  const showPauseButton = isRunning && !isPaused;
  const showResetButton = !isIdle;

  return (
    <div className="timer-controls">
      {showStartButton && (
        <div className="timer-btn-wrapper" onClick={onStart}>
          <button type="button" className="btn btn-success btn-lg timer-btn">
            {getStartButtonLabel()}
          </button>
        </div>
      )}

      {showPauseButton && (
        <div className="timer-btn-wrapper" onClick={onPause}>
          <button type="button" className="btn btn-warning btn-lg timer-btn">
            Pause
          </button>
        </div>
      )}

      {showResetButton && (
        <div className="timer-btn-wrapper" onClick={onReset}>
          <button type="button" className="btn btn-danger btn-lg timer-btn">
            Reset
          </button>
        </div>
      )}
    </div>
  );
}
